(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_city_smartb_s2_s2_automate_dsl.js', './kotlin_kotlin.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_city_smartb_s2_s2_automate_dsl.js'), require('./kotlin_kotlin.js'));
  else {
    if (typeof kotlin_city_smartb_s2_s2_automate_dsl === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_axessimpact_orderbook_domain'. Its dependency 'kotlin_city_smartb_s2_s2_automate_dsl' was not found. Please, check whether 'kotlin_city_smartb_s2_s2_automate_dsl' is loaded prior to 'kotlin_org_axessimpact_orderbook_domain'.");
    }
    if (typeof kotlin_kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_axessimpact_orderbook_domain'. Its dependency 'kotlin_kotlin' was not found. Please, check whether 'kotlin_kotlin' is loaded prior to 'kotlin_org_axessimpact_orderbook_domain'.");
    }
    root.kotlin_org_axessimpact_orderbook_domain = factory(typeof kotlin_org_axessimpact_orderbook_domain === 'undefined' ? {} : kotlin_org_axessimpact_orderbook_domain, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_kotlin);
  }
}(this, function (_, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_kotlin) {
  //region block: imports
  var S2Command = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Command;
  var S2Event = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Event;
  var S2Role = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Role;
  var S2State = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2State;
  var S2InitCommand = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2InitCommand;
  var getStringHashCode = kotlin_kotlin.$crossModule$.getStringHashCode;
  //endregion
  'use strict';
  //region block: pre-declaration
  Created.prototype = Object.create(OrderBookState.prototype);
  Created.prototype.constructor = Created;
  Published.prototype = Object.create(OrderBookState.prototype);
  Published.prototype.constructor = Published;
  Closed.prototype = Object.create(OrderBookState.prototype);
  Closed.prototype.constructor = Closed;
  ExAnte.prototype = Object.create(OrderBookType.prototype);
  ExAnte.prototype.constructor = ExAnte;
  ExPost.prototype = Object.create(OrderBookType.prototype);
  ExPost.prototype.constructor = ExPost;
  Burn.prototype = Object.create(OrderType.prototype);
  Burn.prototype.constructor = Burn;
  Buy.prototype = Object.create(OrderType.prototype);
  Buy.prototype.constructor = Buy;
  Interest.prototype = Object.create(OrderType.prototype);
  Interest.prototype.constructor = Interest;
  Sell.prototype = Object.create(OrderType.prototype);
  Sell.prototype.constructor = Sell;
  //endregion
  function OrderCommand() {
  }
  OrderCommand.$metadata$ = {
    simpleName: 'OrderCommand',
    kind: 'interface',
    interfaces: [S2Command]
  };
  function OrderEvent() {
  }
  OrderEvent.$metadata$ = {
    simpleName: 'OrderEvent',
    kind: 'interface',
    interfaces: [S2Event]
  };
  function Admin() {
  }
  Admin.$metadata$ = {
    simpleName: 'AdminRole',
    kind: 'class',
    interfaces: [S2Role]
  };
  function Created() {
    Created_instance = this;
    OrderBookState.call(this, 0);
  }
  Created.$metadata$ = {
    simpleName: 'Created',
    kind: 'object',
    interfaces: []
  };
  var Created_instance;
  function Created_getInstance() {
    if (Created_instance == null)
      new Created();
    return Created_instance;
  }
  function Published() {
    Published_instance = this;
    OrderBookState.call(this, 1);
  }
  Published.$metadata$ = {
    simpleName: 'Published',
    kind: 'object',
    interfaces: []
  };
  var Published_instance;
  function Published_getInstance() {
    if (Published_instance == null)
      new Published();
    return Published_instance;
  }
  function Closed() {
    Closed_instance = this;
    OrderBookState.call(this, 2);
  }
  Closed.$metadata$ = {
    simpleName: 'Closed',
    kind: 'object',
    interfaces: []
  };
  var Closed_instance;
  function Closed_getInstance() {
    if (Closed_instance == null)
      new Closed();
    return Closed_instance;
  }
  function OrderBookState(position) {
    this.position_1 = position;
  }
  OrderBookState.prototype._set_position__3963083214_ves4de_k$ = function (_set____804775014) {
    this.position_1 = _set____804775014;
  };
  OrderBookState.prototype._get_position__3188952002_iahqv2_k$ = function () {
    return this.position_1;
  };
  OrderBookState.prototype.equals = function (other) {
    var tmp;
    if (other instanceof OrderBookState) {
      tmp = other.position === this.position;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  OrderBookState.prototype.hashCode = function () {
    return this.position;
  };
  OrderBookState.$metadata$ = {
    simpleName: 'OrderBookState',
    kind: 'class',
    interfaces: [S2State]
  };
  Object.defineProperty(OrderBookState.prototype, 'position', {
    configurable: true,
    get: function () {
      return this._get_position__3188952002_iahqv2_k$();
    },
    set: function (value) {
      this._set_position__3963083214_ves4de_k$(value);
    }
  });
  function OrderBookCommand() {
  }
  OrderBookCommand.$metadata$ = {
    simpleName: 'OrderBookCommand',
    kind: 'interface',
    interfaces: [S2Command]
  };
  function OrderBookEvent() {
  }
  OrderBookEvent.$metadata$ = {
    simpleName: 'OrderBookEvent',
    kind: 'interface',
    interfaces: [S2Event]
  };
  function OrderBookInitCommand() {
  }
  OrderBookInitCommand.$metadata$ = {
    simpleName: 'OrderBookInitCommand',
    kind: 'interface',
    interfaces: [S2InitCommand]
  };
  function OrderBookBurnCommandDTO() {
  }
  OrderBookBurnCommandDTO.$metadata$ = {
    simpleName: 'OrderBookBurnCommandDTO',
    kind: 'interface',
    interfaces: [OrderBookCommand]
  };
  function OrderBookBurntEventDTO() {
  }
  OrderBookBurntEventDTO.$metadata$ = {
    simpleName: 'OrderBookBurntEventDTO',
    kind: 'interface',
    interfaces: [OrderBookEvent]
  };
  function OrderBookBuyCommandDTO() {
  }
  OrderBookBuyCommandDTO.$metadata$ = {
    simpleName: 'OrderBookBuyCommandDTO',
    kind: 'interface',
    interfaces: [OrderBookCommand]
  };
  function OrderBookBoughtEventDTO() {
  }
  OrderBookBoughtEventDTO.$metadata$ = {
    simpleName: 'OrderBookBoughtEventDTO',
    kind: 'interface',
    interfaces: [OrderBookEvent]
  };
  function OrderBookCloseCommandDTO() {
  }
  OrderBookCloseCommandDTO.$metadata$ = {
    simpleName: 'OrderBookCloseCommandDTO',
    kind: 'interface',
    interfaces: [OrderBookCommand]
  };
  function OrderBookClosedEventDTO() {
  }
  OrderBookClosedEventDTO.$metadata$ = {
    simpleName: 'OrderBookClosedEventDTO',
    kind: 'interface',
    interfaces: [OrderBookEvent]
  };
  function OrderBookCreateCommandDTO() {
  }
  OrderBookCreateCommandDTO.$metadata$ = {
    simpleName: 'OrderBookCreateCommandDTO',
    kind: 'interface',
    interfaces: [OrderBookInitCommand]
  };
  function OrderBookPublishCommandDTO() {
  }
  OrderBookPublishCommandDTO.$metadata$ = {
    simpleName: 'OrderBookPublishCommandDTO',
    kind: 'interface',
    interfaces: [OrderBookCommand]
  };
  function OrderBookPublishedEventDTO() {
  }
  OrderBookPublishedEventDTO.$metadata$ = {
    simpleName: 'OrderBookPublishedEventDTO',
    kind: 'interface',
    interfaces: [OrderBookEvent]
  };
  function OrderBookSellCommandDTO() {
  }
  OrderBookSellCommandDTO.$metadata$ = {
    simpleName: 'OrderBookSellCommandDTO',
    kind: 'interface',
    interfaces: [OrderBookCommand]
  };
  function OrderBookSoldEventDTO() {
  }
  OrderBookSoldEventDTO.$metadata$ = {
    simpleName: 'OrderBookSoldEventDTO',
    kind: 'interface',
    interfaces: [OrderBookEvent]
  };
  function OrderBookUpdateCommandDTO() {
  }
  OrderBookUpdateCommandDTO.$metadata$ = {
    simpleName: 'OrderBookUpdateCommandDTO',
    kind: 'interface',
    interfaces: [OrderBookCommand]
  };
  function OrderCancelCommandDTO() {
  }
  OrderCancelCommandDTO.$metadata$ = {
    simpleName: 'OrderCancelCommandDTO',
    kind: 'interface',
    interfaces: [OrderCommand]
  };
  function OrderCanceledEventDTO() {
  }
  OrderCanceledEventDTO.$metadata$ = {
    simpleName: 'OrderCanceledEventDTO',
    kind: 'interface',
    interfaces: [OrderEvent]
  };
  function OrderValidateCommandDTO() {
  }
  OrderValidateCommandDTO.$metadata$ = {
    simpleName: 'OrderValidateCommandDTO',
    kind: 'interface',
    interfaces: [OrderCommand]
  };
  function OrderValidatedEventDTO() {
  }
  OrderValidatedEventDTO.$metadata$ = {
    simpleName: 'OrderValidatedEventDTO',
    kind: 'interface',
    interfaces: [OrderEvent]
  };
  function OrderBookDTO() {
  }
  OrderBookDTO.$metadata$ = {
    simpleName: 'OrderBookDTO',
    kind: 'interface',
    interfaces: []
  };
  function OrderBookActionsDTO() {
  }
  OrderBookActionsDTO.$metadata$ = {
    simpleName: 'OrderBookActionsDTO',
    kind: 'interface',
    interfaces: []
  };
  function OrderBookStatusDTO() {
  }
  OrderBookStatusDTO.$metadata$ = {
    simpleName: 'OrderBookStatusDTO',
    kind: 'interface',
    interfaces: []
  };
  function OrderBookStatusValues() {
    OrderBookStatusValues_instance = this;
  }
  OrderBookStatusValues.prototype.created = function () {
    return 'Created';
  };
  OrderBookStatusValues.prototype.published = function () {
    return 'Published';
  };
  OrderBookStatusValues.prototype.closed = function () {
    return 'Closed';
  };
  OrderBookStatusValues.$metadata$ = {
    simpleName: 'OrderBookStatusValues',
    kind: 'object',
    interfaces: []
  };
  var OrderBookStatusValues_instance;
  function OrderBookStatusValues_getInstance() {
    if (OrderBookStatusValues_instance == null)
      new OrderBookStatusValues();
    return OrderBookStatusValues_instance;
  }
  function OrderBookTypeDTO() {
  }
  OrderBookTypeDTO.$metadata$ = {
    simpleName: 'OrderBookTypeDTO',
    kind: 'interface',
    interfaces: []
  };
  function OrderBookTypeValues() {
    OrderBookTypeValues_instance = this;
  }
  OrderBookTypeValues.prototype.exante = function () {
    return ExAnte_getInstance()._get_value__3683422336_a43j40_k$();
  };
  OrderBookTypeValues.prototype.expost = function () {
    return ExPost_getInstance()._get_value__3683422336_a43j40_k$();
  };
  OrderBookTypeValues.$metadata$ = {
    simpleName: 'OrderBookTypeValues',
    kind: 'object',
    interfaces: []
  };
  var OrderBookTypeValues_instance;
  function OrderBookTypeValues_getInstance() {
    if (OrderBookTypeValues_instance == null)
      new OrderBookTypeValues();
    return OrderBookTypeValues_instance;
  }
  function ExAnte() {
    ExAnte_instance = this;
    OrderBookType.call(this, 'ExAnte');
  }
  ExAnte.$metadata$ = {
    simpleName: 'ExAnte',
    kind: 'object',
    interfaces: []
  };
  var ExAnte_instance;
  function ExAnte_getInstance() {
    if (ExAnte_instance == null)
      new ExAnte();
    return ExAnte_instance;
  }
  function ExPost() {
    ExPost_instance = this;
    OrderBookType.call(this, 'ExPost');
  }
  ExPost.$metadata$ = {
    simpleName: 'ExPost',
    kind: 'object',
    interfaces: []
  };
  var ExPost_instance;
  function ExPost_getInstance() {
    if (ExPost_instance == null)
      new ExPost();
    return ExPost_instance;
  }
  function OrderBookType(value) {
    this.value_1 = value;
  }
  OrderBookType.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  OrderBookType.prototype.equals = function (other) {
    var tmp;
    if (other instanceof OrderBookType) {
      tmp = other._get_value__3683422336_a43j40_k$() === this._get_value__3683422336_a43j40_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  OrderBookType.prototype.hashCode = function () {
    return getStringHashCode(this._get_value__3683422336_a43j40_k$());
  };
  OrderBookType.$metadata$ = {
    simpleName: 'OrderBookType',
    kind: 'class',
    interfaces: [OrderBookTypeDTO]
  };
  Object.defineProperty(OrderBookType.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function OrderReviewDTO() {
  }
  OrderReviewDTO.$metadata$ = {
    simpleName: 'OrderReviewDTO',
    kind: 'interface',
    interfaces: []
  };
  function OrderTypeDTO() {
  }
  OrderTypeDTO.$metadata$ = {
    simpleName: 'OrderTypeDTO',
    kind: 'interface',
    interfaces: []
  };
  function OrderTypeValues() {
    OrderTypeValues_instance = this;
  }
  OrderTypeValues.prototype.burn = function () {
    return Burn_getInstance()._get_value__3683422336_a43j40_k$();
  };
  OrderTypeValues.prototype.buy = function () {
    return Buy_getInstance()._get_value__3683422336_a43j40_k$();
  };
  OrderTypeValues.prototype.interest = function () {
    return Interest_getInstance()._get_value__3683422336_a43j40_k$();
  };
  OrderTypeValues.prototype.sell = function () {
    return Sell_getInstance()._get_value__3683422336_a43j40_k$();
  };
  OrderTypeValues.$metadata$ = {
    simpleName: 'OrderTypeValues',
    kind: 'object',
    interfaces: []
  };
  var OrderTypeValues_instance;
  function OrderTypeValues_getInstance() {
    if (OrderTypeValues_instance == null)
      new OrderTypeValues();
    return OrderTypeValues_instance;
  }
  function Burn() {
    Burn_instance = this;
    OrderType.call(this, 'Burn');
  }
  Burn.$metadata$ = {
    simpleName: 'Burn',
    kind: 'object',
    interfaces: []
  };
  var Burn_instance;
  function Burn_getInstance() {
    if (Burn_instance == null)
      new Burn();
    return Burn_instance;
  }
  function Buy() {
    Buy_instance = this;
    OrderType.call(this, 'Buy');
  }
  Buy.$metadata$ = {
    simpleName: 'Buy',
    kind: 'object',
    interfaces: []
  };
  var Buy_instance;
  function Buy_getInstance() {
    if (Buy_instance == null)
      new Buy();
    return Buy_instance;
  }
  function Interest() {
    Interest_instance = this;
    OrderType.call(this, 'Interest');
  }
  Interest.$metadata$ = {
    simpleName: 'Interest',
    kind: 'object',
    interfaces: []
  };
  var Interest_instance;
  function Interest_getInstance() {
    if (Interest_instance == null)
      new Interest();
    return Interest_instance;
  }
  function Sell() {
    Sell_instance = this;
    OrderType.call(this, 'Sell');
  }
  Sell.$metadata$ = {
    simpleName: 'Sell',
    kind: 'object',
    interfaces: []
  };
  var Sell_instance;
  function Sell_getInstance() {
    if (Sell_instance == null)
      new Sell();
    return Sell_instance;
  }
  function OrderType(value) {
    this.value_1 = value;
  }
  OrderType.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  OrderType.prototype.equals = function (other) {
    var tmp;
    if (other instanceof OrderType) {
      tmp = other._get_value__3683422336_a43j40_k$() === this._get_value__3683422336_a43j40_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  OrderType.prototype.hashCode = function () {
    return getStringHashCode(this._get_value__3683422336_a43j40_k$());
  };
  OrderType.$metadata$ = {
    simpleName: 'OrderType',
    kind: 'class',
    interfaces: [OrderTypeDTO]
  };
  Object.defineProperty(OrderType.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    $org$axess$s2$orderbook$domain.Admin = Admin;
    $org$axess$s2$orderbook$domain.OrderBookState = OrderBookState;
    Object.defineProperty($org$axess$s2$orderbook$domain.OrderBookState, 'Created', {
      configurable: true,
      get: Created_getInstance
    });
    Object.defineProperty($org$axess$s2$orderbook$domain.OrderBookState, 'Published', {
      configurable: true,
      get: Published_getInstance
    });
    Object.defineProperty($org$axess$s2$orderbook$domain.OrderBookState, 'Closed', {
      configurable: true,
      get: Closed_getInstance
    });
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$features = $org$axess$s2$orderbook$domain.features || ($org$axess$s2$orderbook$domain.features = {});
    var $org$axess$s2$orderbook$domain$features$command = $org$axess$s2$orderbook$domain$features.command || ($org$axess$s2$orderbook$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$features = $org$axess$s2$orderbook$domain.features || ($org$axess$s2$orderbook$domain.features = {});
    var $org$axess$s2$orderbook$domain$features$command = $org$axess$s2$orderbook$domain$features.command || ($org$axess$s2$orderbook$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$features = $org$axess$s2$orderbook$domain.features || ($org$axess$s2$orderbook$domain.features = {});
    var $org$axess$s2$orderbook$domain$features$command = $org$axess$s2$orderbook$domain$features.command || ($org$axess$s2$orderbook$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$features = $org$axess$s2$orderbook$domain.features || ($org$axess$s2$orderbook$domain.features = {});
    var $org$axess$s2$orderbook$domain$features$command = $org$axess$s2$orderbook$domain$features.command || ($org$axess$s2$orderbook$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$features = $org$axess$s2$orderbook$domain.features || ($org$axess$s2$orderbook$domain.features = {});
    var $org$axess$s2$orderbook$domain$features$command = $org$axess$s2$orderbook$domain$features.command || ($org$axess$s2$orderbook$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$features = $org$axess$s2$orderbook$domain.features || ($org$axess$s2$orderbook$domain.features = {});
    var $org$axess$s2$orderbook$domain$features$command = $org$axess$s2$orderbook$domain$features.command || ($org$axess$s2$orderbook$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$features = $org$axess$s2$orderbook$domain.features || ($org$axess$s2$orderbook$domain.features = {});
    var $org$axess$s2$orderbook$domain$features$command = $org$axess$s2$orderbook$domain$features.command || ($org$axess$s2$orderbook$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$features = $org$axess$s2$orderbook$domain.features || ($org$axess$s2$orderbook$domain.features = {});
    var $org$axess$s2$orderbook$domain$features$command = $org$axess$s2$orderbook$domain$features.command || ($org$axess$s2$orderbook$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$features = $org$axess$s2$orderbook$domain.features || ($org$axess$s2$orderbook$domain.features = {});
    var $org$axess$s2$orderbook$domain$features$command = $org$axess$s2$orderbook$domain$features.command || ($org$axess$s2$orderbook$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$model = $org$axess$s2$orderbook$domain.model || ($org$axess$s2$orderbook$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$model = $org$axess$s2$orderbook$domain.model || ($org$axess$s2$orderbook$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$model = $org$axess$s2$orderbook$domain.model || ($org$axess$s2$orderbook$domain.model = {});
    Object.defineProperty($org$axess$s2$orderbook$domain$model, 'OrderBookStatusValues', {
      configurable: true,
      get: OrderBookStatusValues_getInstance
    });
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$model = $org$axess$s2$orderbook$domain.model || ($org$axess$s2$orderbook$domain.model = {});
    Object.defineProperty($org$axess$s2$orderbook$domain$model, 'OrderBookTypeValues', {
      configurable: true,
      get: OrderBookTypeValues_getInstance
    });
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$model = $org$axess$s2$orderbook$domain.model || ($org$axess$s2$orderbook$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$orderbook = $org$axess$s2.orderbook || ($org$axess$s2.orderbook = {});
    var $org$axess$s2$orderbook$domain = $org$axess$s2$orderbook.domain || ($org$axess$s2$orderbook.domain = {});
    var $org$axess$s2$orderbook$domain$model = $org$axess$s2$orderbook$domain.model || ($org$axess$s2$orderbook$domain.model = {});
    Object.defineProperty($org$axess$s2$orderbook$domain$model, 'OrderTypeValues', {
      configurable: true,
      get: OrderTypeValues_getInstance
    });
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_org_axessimpact_orderbook_domain.js.map